module.exports = __webpack_public_path__ + "9c92609b735997cc284218f8bf48c535.jpeg";